import { render } from "./CompareView.vue?vue&type=template&id=2c9c3561"
import script from "./CompareView.vue?vue&type=script&lang=js"
export * from "./CompareView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__